{
  "familyId": "STU-TABEL",
  "questions": [
    {
      "id": "STU-TABEL-001",
      "familyId": "STU-TABEL",
      "module": "Studievaardig",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "schemas",
      "subSkill": "schema_tabel",
      "questionType": "table_reading",
      "question": "Bekijk de tabel. Hoeveel leerlingen zitten er in groep 7?",
      "context": null,
      "options": ["28", "25", "30", "22"],
      "correctAnswer": 0,
      "data": {
        "headers": ["Groep", "Aantal leerlingen", "Aantal jongens", "Aantal meisjes"],
        "rows": [
          ["Groep 6", "25", "12", "13"],
          ["Groep 7", "28", "15", "13"],
          ["Groep 8", "30", "14", "16"]
        ],
        "selectType": "row",
        "correctSelection": 1,
        "questionTarget": "Groep 7 - Aantal leerlingen"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Tabellen lezen",
            "content": "Zoek de rij voor 'Groep 7'. Kijk dan in de kolom 'Aantal leerlingen'. Waar de rij en kolom elkaar kruisen, vind je het antwoord: 28.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "table_reading_basic",
      "variantIndex": 1,
      "citoDifficulty": 0.18,
      "citoDiscrimination": 0.82,
      "pedagogy": { "dok": 1, "misconceptionTags": [] },
      "feedback": {
        "explanationText": "Zoek de rij 'Groep 7' (tweede rij) en de kolom 'Aantal leerlingen' (tweede kolom). Waar rij en kolom elkaar kruisen, staat het antwoord: 28.",
        "solutionSteps": [
          "Zoek de rij 'Groep 7' in de tabel (tweede rij)",
          "Zoek de kolom 'Aantal leerlingen' (tweede kolom)",
          "Lees het kruispunt af: 28"
        ],
        "distractorExplanations": {
          "0": "Goed! In groep 7 zitten 28 leerlingen.",
          "1": "Je dacht waarschijnlijk dat je de juiste rij had gevonden, maar je las de rij van groep 6 af. 25 hoort bij groep 6, niet bij groep 7. Onthoud: controleer altijd of je de juiste rij hebt.",
          "2": "Je dacht waarschijnlijk dat je de juiste rij had gevonden, maar je las de rij van groep 8 af. 30 hoort bij groep 8, niet bij groep 7. Onthoud: lees de eerste kolom om de juiste rij te vinden.",
          "3": "Je dacht waarschijnlijk dat 22 in de tabel stond. Maar 22 komt niet voor in deze tabel. Onthoud: lees het getal precies af op het kruispunt van de juiste rij en kolom."
        }
      }
    },
    {
      "id": "STU-TABEL-002",
      "familyId": "STU-TABEL",
      "module": "Studievaardig",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "schemas",
      "subSkill": "schema_tabel",
      "questionType": "schedule_reading",
      "question": "Bekijk het rooster. Welk vak heeft groep 7 op dinsdag om 10:00 uur? Klik op het juiste vakje.",
      "context": null,
      "options": [],
      "correctAnswer": "1-1",
      "data": {
        "headers": [],
        "rows": [],
        "schedule": {
          "columns": ["Ma", "Di", "Wo", "Do", "Vr"],
          "timeSlots": ["09:00", "10:00", "11:00"],
          "events": [
            { "row": 0, "col": 0, "content": "Taal", "color": "blue" },
            { "row": 0, "col": 1, "content": "Aardrijkskunde", "color": "green" },
            { "row": 0, "col": 2, "content": "Rekenen", "color": "orange" },
            { "row": 0, "col": 3, "content": "Taal", "color": "blue" },
            { "row": 0, "col": 4, "content": "Rekenen", "color": "orange" },
            { "row": 1, "col": 0, "content": "Rekenen", "color": "orange" },
            { "row": 1, "col": 1, "content": "Rekenen", "color": "orange" },
            { "row": 1, "col": 2, "content": "Taal", "color": "blue" },
            { "row": 1, "col": 3, "content": "Gym", "color": "red" },
            { "row": 1, "col": 4, "content": "Aardrijkskunde", "color": "green" },
            { "row": 2, "col": 0, "content": "Gym", "color": "red" },
            { "row": 2, "col": 1, "content": "Taal", "color": "blue" },
            { "row": 2, "col": 2, "content": "Muziek", "color": "blue" },
            { "row": 2, "col": 3, "content": "Rekenen", "color": "orange" },
            { "row": 2, "col": 4, "content": "Taal", "color": "blue" }
          ]
        }
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Roosters lezen",
            "content": "Zoek de dag 'Di' bovenaan. Zoek het tijdstip '10:00' aan de linkerkant. Kijk waar de kolom en rij elkaar kruisen: Rekenen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "schedule_reading_basic",
      "variantIndex": 2,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.80,
      "pedagogy": { "dok": 2, "misconceptionTags": [] },
      "feedback": {
        "explanationText": "Zoek 'Di' (dinsdag) bovenaan het rooster (tweede kolom) en '10:00' aan de linkerkant (tweede rij). Waar kolom en rij elkaar kruisen, staat het vak: Rekenen.",
        "solutionSteps": [
          "Zoek de kolom 'Di' bovenaan",
          "Zoek de rij '10:00' aan de linkerkant",
          "Klik op het kruispunt: Rekenen"
        ]
      }
    },
    {
      "id": "STU-TABEL-003",
      "familyId": "STU-TABEL",
      "module": "Studievaardig",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "schemas",
      "subSkill": "schema_tabel",
      "questionType": "table_reading",
      "question": "Bekijk de tabel. Hoeveel meisjes zitten er in groep 8?",
      "context": null,
      "options": ["16", "14", "30", "13"],
      "correctAnswer": 0,
      "data": {
        "headers": ["Groep", "Aantal leerlingen", "Aantal jongens", "Aantal meisjes"],
        "rows": [
          ["Groep 6", "25", "12", "13"],
          ["Groep 7", "28", "15", "13"],
          ["Groep 8", "30", "14", "16"]
        ],
        "selectType": "cell",
        "correctSelection": 11,
        "questionTarget": "Groep 8 - Aantal meisjes"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Tabellen lezen — let op de kolom",
            "content": "Zoek de rij voor 'Groep 8'. Kijk dan in de kolom 'Aantal meisjes' (vierde kolom). Let op: 14 is het aantal jongens, niet meisjes. Het juiste antwoord is 16.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "table_reading_basic",
      "variantIndex": 3,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "pedagogy": { "dok": 1, "misconceptionTags": [] },
      "feedback": {
        "explanationText": "Zoek de rij 'Groep 8' (derde rij) en de kolom 'Aantal meisjes' (vierde kolom). Waar rij en kolom kruisen: 16. Let op: de kolom ernaast ('Aantal jongens') geeft 14 — dat is een veelvoorkomende verwisseling.",
        "solutionSteps": [
          "Zoek de rij 'Groep 8' (derde rij)",
          "Zoek de kolom 'Aantal meisjes' (vierde kolom, niet de derde!)",
          "Lees het kruispunt af: 16"
        ],
        "distractorExplanations": {
          "0": "Goed! In groep 8 zitten 16 meisjes.",
          "1": "Je dacht waarschijnlijk dat je de juiste kolom had, maar je las 'Aantal jongens' af in plaats van 'Aantal meisjes'. 14 is het aantal jongens in groep 8. Onthoud: lees de kolomkop goed — 'Aantal meisjes' staat rechts van 'Aantal jongens'.",
          "2": "Je dacht waarschijnlijk dat het totaal het antwoord was. 30 is het totale aantal leerlingen in groep 8 (jongens + meisjes samen), niet alleen de meisjes. Onthoud: lees de specifieke kolom die gevraagd wordt.",
          "3": "Je dacht waarschijnlijk dat je de juiste kolom had, maar je las de verkeerde rij af. 13 is het aantal meisjes in groep 6 en groep 7, niet in groep 8. Onthoud: controleer altijd of je de juiste rij hebt."
        }
      }
    },
    {
      "id": "STU-TABEL-004",
      "familyId": "STU-TABEL",
      "module": "Studievaardig",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "schemas",
      "subSkill": "schema_tabel",
      "questionType": "table_reading",
      "question": "Bekijk de tabel. In welke groep zitten de meeste jongens?",
      "context": null,
      "options": ["Groep 7", "Groep 6", "Groep 8", "In alle groepen evenveel"],
      "correctAnswer": 0,
      "data": {
        "headers": ["Groep", "Aantal leerlingen", "Aantal jongens", "Aantal meisjes"],
        "rows": [
          ["Groep 6", "25", "12", "13"],
          ["Groep 7", "28", "15", "13"],
          ["Groep 8", "30", "14", "16"]
        ],
        "selectType": "column",
        "correctSelection": 2,
        "questionTarget": "Kolom Aantal jongens - hoogste waarde"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Tabel vergelijken",
            "content": "Kijk in de kolom 'Aantal jongens': Groep 6 = 12, Groep 7 = 15, Groep 8 = 14. Het hoogste getal is 15, dus in Groep 7 zitten de meeste jongens.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "table_reading_compare",
      "variantIndex": 4,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.77,
      "pedagogy": { "dok": 2, "misconceptionTags": [] },
      "feedback": {
        "explanationText": "Lees de kolom 'Aantal jongens' af: Groep 6 = 12, Groep 7 = 15, Groep 8 = 14. Vergelijk: 12 < 14 < 15. Het hoogste getal is 15 → Groep 7 heeft de meeste jongens.",
        "solutionSteps": [
          "Lees de kolom 'Aantal jongens' af: 12, 15, 14",
          "Vergelijk de getallen: 12 < 14 < 15",
          "Het hoogste getal (15) hoort bij Groep 7"
        ],
        "distractorExplanations": {
          "0": "Goed! Groep 7 heeft 15 jongens — meer dan groep 6 (12) en groep 8 (14).",
          "1": "Je dacht waarschijnlijk dat groep 6 de meeste jongens had. Maar groep 6 heeft 12 jongens, en groep 7 heeft er 15. Onthoud: vergelijk altijd alle waarden in de kolom voordat je een antwoord kiest.",
          "2": "Je dacht waarschijnlijk dat de groep met de meeste leerlingen ook de meeste jongens heeft. Groep 8 heeft de meeste leerlingen (30), maar niet de meeste jongens (14). Onthoud: kijk in de juiste kolom — 'Aantal jongens', niet 'Aantal leerlingen'.",
          "3": "Je dacht waarschijnlijk dat de aantallen gelijk waren zonder te controleren. De aantallen zijn 12, 15 en 14 — niet gelijk. Onthoud: lees altijd de getallen af en vergelijk ze."
        }
      }
    },
    {
      "id": "STU-TABEL-005",
      "familyId": "STU-TABEL",
      "module": "Studievaardig",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "schemas",
      "subSkill": "schema_tabel",
      "questionType": "table_reading",
      "question": "Bekijk de tabel. Hoeveel leerlingen zitten er in totaal in alle drie de groepen?",
      "context": null,
      "options": ["83", "53", "28", "90"],
      "correctAnswer": 0,
      "data": {
        "headers": ["Groep", "Aantal leerlingen", "Aantal jongens", "Aantal meisjes"],
        "rows": [
          ["Groep 6", "25", "12", "13"],
          ["Groep 7", "28", "15", "13"],
          ["Groep 8", "30", "14", "16"]
        ],
        "selectType": "column",
        "correctSelection": 1,
        "questionTarget": "Kolom Aantal leerlingen - totaal"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Tabel optellen",
            "content": "Tel de waarden in de kolom 'Aantal leerlingen' bij elkaar op: 25 + 28 + 30 = 83. Tip: 25 + 28 = 53, dan 53 + 30 = 83.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "table_reading_sum",
      "variantIndex": 5,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.79,
      "pedagogy": { "dok": 2, "misconceptionTags": [] },
      "feedback": {
        "explanationText": "Lees de kolom 'Aantal leerlingen' af: 25, 28, 30. Reken stap voor stap: 25 + 28 = 53, dan 53 + 30 = 83. Er zitten in totaal 83 leerlingen in de drie groepen.",
        "solutionSteps": [
          "Lees de kolom 'Aantal leerlingen' af: 25, 28, 30",
          "Tel stap voor stap op: 25 + 28 = 53",
          "53 + 30 = 83 leerlingen in totaal"
        ],
        "distractorExplanations": {
          "0": "Goed! 25 + 28 + 30 = 83 leerlingen in totaal.",
          "1": "Je dacht waarschijnlijk dat je klaar was na twee groepen. 53 = 25 + 28, maar je bent vergeten groep 8 (30) erbij op te tellen. Onthoud: tel alle rijen op, niet alleen de eerste twee.",
          "2": "Je dacht waarschijnlijk dat je maar één waarde hoefde af te lezen. 28 is alleen het aantal leerlingen in groep 7. Onthoud: bij 'totaal' moet je alle waarden in de kolom bij elkaar optellen.",
          "3": "Je dacht waarschijnlijk dat het antwoord 90 was. Maar 25 + 28 + 30 = 83, niet 90. Onthoud: controleer je optelling stap voor stap."
        }
      }
    },
    {
      "id": "STU-TABEL-006",
      "familyId": "STU-TABEL",
      "module": "Studievaardig",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "schemas",
      "subSkill": "schema_tabel",
      "questionType": "ordering",
      "question": "Zet de stappen om een tabel te lezen in de juiste volgorde.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": [
          "Lees de titel en de kopjes",
          "Zoek de juiste rij",
          "Zoek de juiste kolom",
          "Lees de waarde op het kruispunt af",
          "Controleer je antwoord"
        ],
        "correctOrder": [0, 1, 2, 3, 4]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stappenplan tabel lezen",
            "content": "Begin altijd met de titel en kopjes om te weten waar de tabel over gaat. Zoek dan de rij en de kolom. Op het kruispunt vind je het antwoord. Controleer tot slot of het klopt.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "table_reading_steps",
      "variantIndex": 6,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.75,
      "pedagogy": { "dok": 2, "misconceptionTags": [] },
      "feedback": {
        "explanationText": "De juiste volgorde is: 1) Lees de titel en de kopjes (wat staat er in de tabel?), 2) Zoek de juiste rij, 3) Zoek de juiste kolom, 4) Lees de waarde op het kruispunt af, 5) Controleer je antwoord.",
        "solutionSteps": [
          "1. Lees de titel en de kopjes",
          "2. Zoek de juiste rij",
          "3. Zoek de juiste kolom",
          "4. Lees de waarde op het kruispunt af",
          "5. Controleer je antwoord"
        ]
      }
    },
    {
      "id": "STU-TABEL-007",
      "familyId": "STU-TABEL",
      "module": "Studievaardig",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "schemas",
      "subSkill": "schema_tabel",
      "questionType": "true_false_series",
      "question": "Klopt elke bewering over de leerlingen-tabel?",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          {
            "text": "In groep 8 zitten meer jongens dan meisjes.",
            "isTrue": false,
            "explanation": "In groep 8 zitten 14 jongens en 16 meisjes. Er zijn dus meer meisjes dan jongens."
          },
          {
            "text": "Groep 6 heeft het kleinste aantal leerlingen.",
            "isTrue": true,
            "explanation": "Groep 6 heeft 25 leerlingen, groep 7 heeft er 28 en groep 8 heeft er 30. Groep 6 is inderdaad het kleinst."
          },
          {
            "text": "Het totaal aantal jongens is 41.",
            "isTrue": true,
            "explanation": "Tel de jongens op: 12 (groep 6) + 15 (groep 7) + 14 (groep 8) = 41. Dat klopt."
          },
          {
            "text": "Groep 7 heeft evenveel jongens als meisjes.",
            "isTrue": false,
            "explanation": "In groep 7 zitten 15 jongens en 13 meisjes. Dat is niet evenveel."
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "rule",
          "data": {
            "title": "Tabel Leerlingen",
            "content": "Groep | Aantal leerlingen | Aantal jongens | Aantal meisjes\nGroep 6 | 25 | 12 | 13\nGroep 7 | 28 | 15 | 13\nGroep 8 | 30 | 14 | 16",
            "icon": "book"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Tabel goed aflezen",
            "content": "Lees per bewering de juiste rij en kolom af. Vergelijk de getallen of tel ze op om te zien of de bewering waar of onwaar is.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "table_reading_judge",
      "variantIndex": 7,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 3, "misconceptionTags": [] },
      "feedback": {
        "explanationText": "Controleer elke bewering in de tabel. Groep 8 heeft 14 jongens en 16 meisjes (onwaar). Groep 6 heeft 25 leerlingen, wat het minste is (waar). Totaal jongens is 12+15+14=41 (waar). Groep 7 heeft 15 jongens en 13 meisjes (onwaar).",
        "solutionSteps": [
          "Lees elke bewering",
          "Zoek de bijbehorende getallen in de tabel",
          "Controleer of de bewering klopt met de getallen"
        ]
      }
    }
  ]
}